import { BreadCrumbs } from "@alliancesafetycouncil/asc-breadcrumbs";
import PageTitle from "@alliancesafetycouncil/asc-page-title";
import React, { Component } from "react";
import { connect } from "react-redux";
import FormContainer from "../../../components/FormContainer/FormContainer";
import { HeaderActions } from "../../../components/HeaderActions/HeaderActions";
import { Header } from "../../../containers/Layout/Header";
import EditRequirementForm from "./EditRequirementForm";

class EditRequirement extends Component {
  setRef = (ref) => {
    this.setState({
      editorRef: ref,
    });
  };

  render() {
    const { details, requirementDetails } = this.props;
    const { id } = this.props.match.params;
    console.log(requirementDetails);
    const links = [
      {
        title: details.company.name,
        link: `/#/companies/company-details/${details.company.id}/sites`,
      },
      {
        title: details.name,
        link: `/#/sites/site-details/${details.id}/sites-requirements`,
      },
      {
        title: requirementDetails.name,
      },
    ];

    return (
      <div className="flex flex-col bg-blue-50 h-full">
        <Header>
          <div className="pr-6 w-4/6">
            <BreadCrumbs crumbs={links} />
          </div>
          <div className="w-2/6">{this.props.auth && <HeaderActions />}</div>
        </Header>
        <div className="row header flex-initial mx-4 h-20 flex items-center">
          <PageTitle>
            <i className="fal fa-building text-orange-500 mr-2"></i>Edit Requirement
          </PageTitle>
        </div>
        <div className="mb-4 content flex-auto mx-4">
          <FormContainer
            {...this.props}
            setRef={this.setRef}
            initialValues={{
              name: requirementDetails.name,
              notes: requirementDetails.notes,
            }}
            setDocuments={this.setDocuments}
            entity="requirements"
            action="edit"
            redirect={`/requirements/requirement-details/${id}/documents`}
            Form={EditRequirementForm}
            handleValues={(values) => {
              const payload = {
                ...values,
                notes: this.state.editorRef.getContent(),
              };

              return payload;
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    details: state.siteService.details,
    requirementDetails: state.siteService.requirementDetails,
  };
};

export default connect(mapStateToProps, null)(EditRequirement);
